/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.
import { Injectable } from "@angular/core";
import { Client, generateClient, GraphQLResult } from "aws-amplify/api";
import { Observable } from "rxjs";

export type __SubscriptionContainer = {
  onCreateVRView: OnCreateVRViewSubscription;
  onUpdateVRView: OnUpdateVRViewSubscription;
};

export type CreateVRViewInput = {
  viewID: string;
  setID?: string | null;
  date: string;
  category: string;
};

export type VRView = {
  __typename: "VRView";
  viewID: string;
  setID?: string | null;
  date: string;
};

export type UpdateVRViewInput = {
  viewID: string;
  setID?: string | null;
  date: string;
};

export type DeleteVRViewInput = {
  viewID: string;
  setID?: string | null;
  date: string;
};

export type TableVRViewFilterInput = {
  viewID?: TableStringFilterInput | null;
  setID?: TableStringFilterInput | null;
  date?: TableStringFilterInput | null;
};

export type TableStringFilterInput = {
  ne?: string | null;
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  contains?: string | null;
  notContains?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
};

export type VRViewConnection = {
  __typename: "VRViewConnection";
  items?: Array<VRView | null> | null;
  nextToken?: string | null;
};

export type CreateVRViewMutation = {
  __typename: "VRView";
  viewID: string;
  setID?: string | null;
  date: string;
};

export type UpdateVRViewMutation = {
  __typename: "VRView";
  viewID: string;
  setID?: string | null;
  date: string;
};

export type DeleteVRViewMutation = {
  __typename: "VRView";
  viewID: string;
  setID?: string | null;
  date: string;
};

export type GetVRViewQuery = {
  __typename: "VRView";
  viewID: string;
  setID?: string | null;
  date: string;
};

export type ListVRViewsQuery = {
  __typename: "VRViewConnection";
  items?: Array<{
    __typename: "VRView";
    viewID: string;
    setID?: string | null;
    date: string;
  } | null> | null;
  nextToken?: string | null;
};

export type GetLastVRViewQuery = {
  __typename: "VRView";
  viewID: string;
  setID?: string | null;
  date: string;
};

export type OnCreateVRViewSubscription = {
  __typename: "VRView";
  viewID: string;
  setID?: string | null;
  date: string;
};

export type OnUpdateVRViewSubscription = {
  __typename: "VRView";
  viewID: string;
  setID?: string | null;
  date: string;
};

@Injectable({
  providedIn: "root"
})
export class APIService {
  public client: Client;
  constructor() {
    //@ts-ignore
    this.client = generateClient();
  }
  async CreateVRView(input: CreateVRViewInput): Promise<CreateVRViewMutation> {
    const statement = `mutation CreateVRView($input: CreateVRViewInput!) {
        createVRView(input: $input) {
          __typename
          viewID
          setID
          date
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <CreateVRViewMutation>response.data.createVRView;
  }
  async UpdateVRView(input: UpdateVRViewInput): Promise<UpdateVRViewMutation> {
    const statement = `mutation UpdateVRView($input: UpdateVRViewInput!) {
        updateVRView(input: $input) {
          __typename
          viewID
          setID
          date
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <UpdateVRViewMutation>response.data.updateVRView;
  }
  async DeleteVRView(input: DeleteVRViewInput): Promise<DeleteVRViewMutation> {
    const statement = `mutation DeleteVRView($input: DeleteVRViewInput!) {
        deleteVRView(input: $input) {
          __typename
          viewID
          setID
          date
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <DeleteVRViewMutation>response.data.deleteVRView;
  }
  async GetVRView(
    viewID: string,
    date: string,
    setID?: string
  ): Promise<GetVRViewQuery> {
    const statement = `query GetVRView($viewID: String!, $setID: String, $date: String!) {
        getVRView(viewID: $viewID, setID: $setID, date: $date) {
          __typename
          viewID
          setID
          date
        }
      }`;
    const gqlAPIServiceArguments: any = {
      viewID,
      date
    };
    if (setID) {
      gqlAPIServiceArguments.setID = setID;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <GetVRViewQuery>response.data.getVRView;
  }
  async ListVRViews(
    filter?: TableVRViewFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListVRViewsQuery> {
    const statement = `query ListVRViews($filter: TableVRViewFilterInput, $limit: Int, $nextToken: String) {
        listVRViews(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            viewID
            setID
            date
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <ListVRViewsQuery>response.data.listVRViews;
  }
  async GetLastVRView(): Promise<GetLastVRViewQuery> {
    const statement = `query GetLastVRView {
        getLastVRView {
          __typename
          viewID
          setID
          date
        }
      }`;
    const response = (await this.client.graphql({ query: statement })) as any;
    return <GetLastVRViewQuery>response.data.getLastVRView;
  }
  OnCreateVRViewListener(): Observable<
    GraphQLResult<Pick<__SubscriptionContainer, "onCreateVRView">>
  > {
    return this.client.graphql({
      query: `subscription OnCreateVRView {
        onCreateVRView {
          __typename
          viewID
          setID
          date
        }
      }`
    }) as any;
  }

  OnUpdateVRViewListener(
    viewID?: string
  ): Observable<
    GraphQLResult<Pick<__SubscriptionContainer, "onUpdateVRView">>
  > {
    const statement = `subscription OnUpdateVRView($viewID: String) {
        onUpdateVRView(viewID: $viewID) {
          __typename
          viewID
          setID
          date
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (viewID) {
      gqlAPIServiceArguments.viewID = viewID;
    }
    return this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    }) as any;
  }
}
